import script from "./ServiciosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiciosView.vue?vue&type=script&setup=true&lang=js"

import "./ServiciosView.vue?vue&type=style&index=0&id=6969116c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6969116c"]])

export default __exports__